/**
 * OpenhomeCardBody
 * 
 * @Author: Focci
 * @Date: 2023-08-16 22:25:29
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-16 22:25:29
 */

// import PropTypes from 'prop-types'
import { formatDate } from '@lib/datetime'
import { useLocale } from 'next-intl'

export default function OpenhomeCardBody({
  auction = false,
  data = {}
}) {
  const lang = useLocale()
  
  return (
    <>
      <div className="flex flex-col items-center pr-3 leading-none border-r">
        <span className="text-f.8">
          {formatDate(data.time_start, 'MMM', lang)}
        </span>
        <span className="text-[1.4rem] font-medium">
          {formatDate(data.time_start, 'DD', lang)}
        </span>
      </div>
      <div className="flex flex-col items-start leading-none mr-auto">
        <span className="text-f.8">
          {formatDate(data.time_start, 'dddd', lang)}
        </span>
        <span className="text-base mt-1 whitespace-nowrap">
          {formatDate(data.time_start, 'HH:mm', lang)}
          {!auction && (
            <>
              <span> - </span>
              {formatDate(data.time_end, 'HH:mm', lang)}
            </>
          )}
        </span>
      </div>
    </>
  )
}

// OpenhomeCardBody.propTypes = {
//   className: PropTypes.string,
// }
